import styled from "styled-components";

import { FlexBox, Heading } from "@braze/beacon-core";
import { getSpacing } from "@braze/beacon-styling";

export const StyledFlexBox = styled(FlexBox)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(100% - 40px);
  min-height: 325px;
  height: 325px;
  background-color: #f5f5f5;
  border-radius: 60px 60px 0 0;
  margin-top: auto;
  padding: 0 20px;
  gap: ${getSpacing("xxl")};
  @media (max-width: 1220px) {
    display: none;
  }
`;

export const TrustBarContainer = styled(FlexBox)`
  max-width: 1248px;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 32px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const StyledImage = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;
`;

export const TrustBarHeader = styled(Heading)``;
